import { filterCandidate } from './services';

// Action Types
export const FILTER_CANDIDATE_REQUEST = 'FILTER_CANDIDATE_REQUEST';
export const FILTER_CANDIDATE_SUCCESS = 'FILTER_CANDIDATE_SUCCESS';
export const FILTER_CANDIDATE_FAILURE = 'FILTER_CANDIDATE_FAILURE';

// Action Creators
export const filterCandidateRequest = () => {
  return {
    type: FILTER_CANDIDATE_REQUEST,
  };
};

export const filterCandidateSuccess = (candidates) => {
  return {
    type: FILTER_CANDIDATE_SUCCESS,
    payload: candidates,
  };
};

export const filterCandidateFailure = (error) => {
  return {
    type: FILTER_CANDIDATE_FAILURE,
    payload: error,
  };
};

export const filterCandidateAction = (filters) => async (dispatch) => {
  console.log(filters);
  try {
    dispatch(filterCandidateRequest());

    const response = await filterCandidate(filters);
    dispatch(filterCandidateSuccess(response.data));
  } catch (error) {
    console.log(error);
    dispatch(filterCandidateFailure(error.message));
  }
};
